<nav class="breadcrumb-container" aria-label="ניווט היררכי">
  <ol class="breadcrumb-list">
    @for (crumb of breadcrumbs; track crumb.url; let last = $last; let first = $first) {
      <li class="breadcrumb-item" [class.is-home]="first" [class.is-current]="last">
        @if (first) { <mat-icon class="home-icon" aria-hidden="true">home</mat-icon> }
        @if (last) {
          <span class="breadcrumb-current" aria-current="page">{{ crumb.label }}</span>
        } @else {
          <a [routerLink]="crumb.url">{{ crumb.label }}</a>
          <mat-icon aria-hidden="true" class="separator">chevron_left</mat-icon>
        }
      </li>
    }
  </ol>
  <div class="breadcrumb-actions" aria-label="פעולות תצוגה">
    <ng-content></ng-content>
  </div>
</nav>
